import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavItems } from "./useNavItems";
import { useApprovalsCount } from "../../hooks/useApprovalsCount";

const ACTIVE = "border-primary/40 text-primary shadow-neu-in";
const IDLE = "border-border/60 text-muted-foreground shadow-neu-sm hover:-translate-y-0.5 hover:text-foreground";

// تنقّل برمجي (زر لا رابط) كي لا يُظهر المتصفح عنوان الـURL في شريط الحالة أسفل الشاشة.
export const SideNav = () => {
  const { t } = useTranslation();
  const { allowed } = useNavItems();
  const approvals = useApprovalsCount();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = (to) => (to === "/" ? pathname === "/" : pathname === to || pathname.startsWith(`${to}/`));

  return (
    <nav className="flex w-full min-w-0 flex-col gap-2" data-testid="side-nav">
      {allowed.map(({ to, key, icon: Icon }) => (
        <button
          key={to}
          type="button"
          onClick={() => navigate(to)}
          data-testid={`nav-${key}`}
          className={[
            "flex items-center gap-3 rounded-2xl border px-4 py-3 text-start text-sm font-semibold",
            "transition-[box-shadow,color,transform] duration-300",
            isActive(to) ? ACTIVE : IDLE,
          ].join(" ")}
        >
          <Icon className="h-4 w-4" />
          <span className="whitespace-nowrap">{t(`nav.${key}`)}</span>
          {key === "requests" && approvals > 0 ? (
            <span data-testid="approvals-badge"
                  className="ms-auto inline-flex min-w-[20px] items-center justify-center rounded-full bg-destructive px-1.5 text-[11px] font-black text-white">
              {approvals}
            </span>
          ) : null}
        </button>
      ))}
    </nav>
  );
};
